// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class ListItem extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    noBullet: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    children: null,
    noBullet: false,
  };

  render() {
    const { className, noBullet, ...more } = this.props;
    const listItemClassName = classNames(className, 'list__item');

    return (
      <li className={`${listItemClassName} ${noBullet ? 'list__item__no_bullet' : null}`} {...more}>
        {this.props.children}
      </li>
    );
  }
}

export default ListItem;
